import { updateTeamRole } from './types';

const updateTeamRoleReducerObject = {
  [updateTeamRole.request]: (state, action) =>
    state.setIn(['updateRole', action.userId, 'network', 'loading'], true),
  [updateTeamRole.success]: (state, action) =>
    state.withMutations((s) =>
      s
        .setIn(['updateRole', action.userId, 'network', 'loading'], false)
        .setIn(['updateRole', action.userId, 'network', 'error'], false)
        .setIn(['membersById', action.userId, 'roles'], action.roles),
    ),
  [updateTeamRole.failure]: (state, action) =>
    state.withMutations((s) =>
      s
        .setIn(['updateRole', action.userId, 'network', 'loading'], false)
        .setIn(['updateRole', action.userId, 'network', 'error'], action.error),
    ),
};

export default updateTeamRoleReducerObject;
